<template>
    <div class="py-4 px-10 main-bg-item-dark-color">
        <tabs
            v-model="activeTabName"
            square
            @tab-remove="removeTab"
            :class="$rtl.isRTL ? 'rtl' : 'ltr'"
        >
            <tab-pane
                v-for="item in dataTabs"
                :key="item.name"
                :label="item.title"
                :name="item.name"
                :closable="item.name !== listTabName">
                <template>
                    <slot 
                        :name="item.name"
                        :label="item.title"
                        :data="item.data"
                    />
                </template>
                <span slot="label" class="flex justify-center items-center">
                    <i :class="item.icon" class="icon-md"/>
                    <span class="mx-2">
                        {{ $t(item.title) }}
                    </span>
                </span>
            </tab-pane>
        </tabs>
    </div>
</template>

<script>
import TabPane from '@/modules/common/components/tabs/TabPane.vue'
import Tabs from '@/modules/common/components/tabs/Tabs.vue'

const CREATE_TAB_NAME = 'create';
const LIST_TAB_NAME = 'list'

export default {
    name: "report-tabs",
    components: {
        TabPane,
        Tabs
    },
    props: {
        dataTabs: {
            type: Array,
            default: []
        },
        activeTab: {
            type: String,
            default: LIST_TAB_NAME
        }
    },
    data() {
        return {
            createTabName: CREATE_TAB_NAME,
            listTabName: LIST_TAB_NAME,
            activeTabName: this.activeTab || LIST_TAB_NAME
        }
    },
    watch: {
        activeTabName(val) {
            this.$emit('update-active-tab', val)
        },
        activeTab: {
            immediate: true,
            handler(val) {
                this.activeTabName = val
            }
        }
    },
    methods: {
        removeTab(tab) {
            this.$emit('on-remove-tab', tab)
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep #tab-create {
    display: flex !important;
}
::v-deep .el-tabs__item:not(:first-child) {
    display: flex;
    justify-content: center;
    align-items: center;
}
::v-deep .el-tabs__nav {
    display: flex;
}
.rtl ::v-deep .el-tabs__nav {
    float: right !important;
    flex-direction: row;
}
.report-edit ::v-deep .el-tabs__item {
    padding-left: 0px;
}
</style>
